import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NoticeManagementPage from '../admin/noticemanagement/NoticeManagementPage';
import AlarmNoticeManagement from 'pages/admin/alarmNoticeManagement/AlarmNoticeManagement';
import { getProjectAlarmListCnt } from 'apis/admin/Alarm';
import useSessionStore from 'stores/useSessionStore';

const MainPage = () => {
  const { pathname } = useLocation();
  const [openAlarmPopup, setOpenAlarmPopup] = useState<boolean>(false);
  const hasFA = useSessionStore.getState().roleCodes.some((code) => code?.includes('FA_')); //FA 권한자인지 찾음

  const getAlarmList = async () => {
    getProjectAlarmListCnt().then((result: number) => {
      if (result > 0 && hasFA) {
        setOpenAlarmPopup(true);
      }
    });
  };

  useEffect(() => {
    if (pathname == '/') {
      getAlarmList();
    }
  }, [pathname]);

  return (
    <>
      <NoticeManagementPage />
      {openAlarmPopup && (
        <AlarmNoticeManagement open={openAlarmPopup} close={() => setOpenAlarmPopup(false)} />
      )}
    </>
  );
};

export default MainPage;
